import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../../../../../store/marketing/publicador/MarketingPublicador';

import Formsy from 'formsy-react';
import { Row, Modal, Alert } from 'react-bootstrap';
import AlertError from '../../../../commons/AlertError';
import AlertSuccess from '../../../../commons/AlertSuccess';
import CurrencyInput from 'react-currency-input';
import BtnSalvar from '../../../../commons/BtnSalvar';
import BtnCancelar from '../../../../commons/BtnCancelar';
import SwitchOnOff from '../../../../commons/SwitchOnOff';
import InputTextValidated from '../../../../commons/InputTextValidated';
import TextAreaValidated from '../../../../commons/TextAreaValidated';


class ModalWebSiteBNDV extends React.Component {
    constructor() {
        super();
        this.handleSubmit = this.handleSubmit.bind(this);

        this.state = {

        }
    }

    async componentDidMount() {
        this.props.PublicarVeiculo.anuncio.idCategoria = 1;

        if (this.props.ModalWebSiteBNDV.showModal) {
            if (this.props.PublicarVeiculo.anuncio.idAnuncioBNDV != null && this.props.PublicarVeiculo.anuncio.idAnuncioBNDV != 0) {
                this.props.PublicarVeiculo.errorText = "";
                this.props.PublicarVeiculo.successText = "";
                await this.props.fnBuscarVeiculo();
                await this.props.fnBuscarAnuncio();
                this.props.PublicarVeiculo.anuncio.idVersao = this.props.PublicarVeiculo.veiculoBNDV.descVersao;
                this.props.fnUpdateState(this.props);
            }
            else {
                await this.props.fnBuscarVeiculo();

                this.props.PublicarVeiculo.errorText = "";
                this.props.PublicarVeiculo.successText = "";
                this.props.PublicarVeiculo.anuncio.idVersao = this.props.PublicarVeiculo.veiculoBNDV.descVersao;
                this.props.fnUpdateState(this.props);
            }
        }
    }

    handleSubmit() {
        if (this.props.PublicarVeiculo.anuncio.idAnuncioBNDV == 0)
            this.props.fnPublicar();
        else
            this.props.fnAlterarAnuncio();
    }

    handleOnHide() {
        this.props.ModalWebSiteBNDV.showModal = false;
        this.props.fnUpdateState(this.props);
    }

    render() {
        return <Modal
            show={this.props.ModalWebSiteBNDV.showModal}
            onHide={this.handleOnHide.bind(this)}
            bsSize="large"
        >
            <Formsy onValidSubmit={this.handleSubmit}>
                <Modal.Header closeButton>
                    <h4 className="modal-title custom-font">Publicar no site da Loja</h4>
                </Modal.Header>
                <Modal.Body>
                    <AlertSuccess
                        successText={this.props.PublicarVeiculo.successText}
                        alertVisible={this.props.PublicarVeiculo.successText != '' && this.props.PublicarVeiculo.successText != undefined ? true : false}
                        onDismiss={(alertVisible, successText) => {
                            this.props.PublicarVeiculo.successText = successText;
                            this.props.fnUpdateState(this.props);
                        }}
                    />
                    <AlertError
                        errorText={this.props.PublicarVeiculo.errorText}
                        alertVisible={this.props.PublicarVeiculo.errorText != '' && this.props.PublicarVeiculo.errorText != undefined ? true : false}
                        onDismiss={(alertVisible, errorText) => {
                            this.props.PublicarVeiculo.errorText = errorText;
                            this.props.fnUpdateState(this.props);
                        }}
                    />
                    <Row>
                        <div className="form-group col-md-5">
                            <div className="form-group col-md-12 legend">
                                <h4><strong>Dados Veículo</strong></h4>
                            </div>
                            <dl className="dl-horizontal">
                                <dt>Placa:</dt>
                                <dd>{this.props.PublicarVeiculo.veiculoBNDV.placa}</dd>
                                <dt>Chassi:</dt>
                                <dd>{this.props.PublicarVeiculo.veiculoBNDV.chassi}</dd>
                                <dt>Marca:</dt>
                                <dd>{this.props.PublicarVeiculo.veiculoBNDV.descMarca}</dd>
                                <dt>Modelo:</dt>
                                <dd>{this.props.PublicarVeiculo.veiculoBNDV.descModelo}</dd>
                                <dt>Versão:</dt>
                                <dd>{this.props.PublicarVeiculo.veiculoBNDV.descVersao}</dd>
                                <dt>Câmbio:</dt>
                                <dd>{this.props.PublicarVeiculo.veiculoBNDV.descCambio}</dd>
                                <dt>Combustível:</dt>
                                <dd>{this.props.PublicarVeiculo.veiculoBNDV.descCombustivel}</dd>
                                <dt>Portas:</dt>
                                <dd>{this.props.PublicarVeiculo.veiculoBNDV.descPortas}</dd>
                                <dt>Cor:</dt>
                                <dd>{this.props.PublicarVeiculo.veiculoBNDV.cor}</dd>
                                <dt>Ano Modelo:</dt>
                                <dd>{this.props.PublicarVeiculo.veiculoBNDV.anoModelo}</dd>
                                <dt>Ano Fabricação:</dt>
                                <dd>{this.props.PublicarVeiculo.veiculoBNDV.anoFabricacao}</dd>
                                <dt>KM:</dt>
                                <dd>{this.props.PublicarVeiculo.veiculoBNDV.km}</dd>
                            </dl>
                            <div className="form-group col-md-12 legend">
                                <h4><strong>Opcionais</strong></h4>
                            </div>
                            <dl className="form-group col-md-12">
                                <p>{this.props.PublicarVeiculo.veiculoBNDV.opcionais}</p>
                            </dl>
                        </div>
                        <div className="form-group col-md-7">
                            <div className="tile-body">
                                <div className="form-group col-md-12">
                                    <Alert bsStyle="warning">
                                        <strong>ATENÇÃO!</strong><br />
                                        Prezado cliente a publicação no site da loja é automático, você pode incluir o valor que quiser de venda para que apareça em seu site basta apenas alterar o valor no campo abaixo, boas vendas!
                                        </Alert>
                                </div>
                                <InputTextValidated
                                    name="txtVersao"
                                    type="text"
                                    className="col-md-12"
                                    placeholder="Informe a versão do veículo"
                                    onChange={(name, value) => {
                                        this.props.PublicarVeiculo.anuncio.idVersao = value;
                                        this.props.fnUpdateState(this.props);
                                    }}
                                    value={this.props.PublicarVeiculo.anuncio.idVersao}
                                    title="Versão:"
                                    required
                                />
                                <div className="form-group col-md-6">
                                    <label>Valor promocional</label>
                                    <CurrencyInput
                                        decimalSeparator="."
                                        thousandSeparator=""
                                        className="form-control"
                                        id="txtValorPromocional"
                                        onChange={(x) => {
                                            this.props.PublicarVeiculo.anuncio.precoDe = parseFloat(x);
                                            this.props.fnUpdateState(this.props);
                                        }}
                                        inputType="text"
                                        value={this.props.PublicarVeiculo.anuncio.precoDe}
                                    />
                                </div>
                                <div className="form-group col-md-6">
                                    <label>Valor para anúncio</label>
                                    <CurrencyInput
                                        decimalSeparator="."
                                        thousandSeparator=""
                                        className="form-control"
                                        id="txtValorAnuncio"
                                        onChange={(x) => {
                                            this.props.PublicarVeiculo.anuncio.preco = parseFloat(x);
                                            this.props.fnUpdateState(this.props);
                                        }}
                                        inputType="text"
                                        value={this.props.PublicarVeiculo.anuncio.preco}
                                    />
                                </div>
                                <div className="form-group col-md-12">
                                    <label>Anúncio em destaque?</label><br />
                                    <SwitchOnOff
                                        class="onoffswitch-checkbox"
                                        id="chkDestaqueMeuCarroNovo"
                                        onChange={(name, value) => {
                                            this.props.PublicarVeiculo.anuncio.anuncioEmDestaque = (value == 'on' ? false : true);
                                            this.props.fnUpdateState(this.props);
                                        }}
                                        value={this.props.PublicarVeiculo.anuncio.anuncioEmDestaque == true ? 'on' : 'off'}
                                    />
                                </div>
                                <TextAreaValidated
                                    name="txtDescricao"
                                    className="col-md-12"
                                    placeholder="Informe a descrição do anúncio"
                                    rows={6}
                                    onChange={(name, value) => {
                                        this.props.PublicarVeiculo.anuncio.texto = value;
                                        this.props.fnUpdateState(this.props);
                                    }}
                                    value={this.props.PublicarVeiculo.anuncio.texto}
                                    title="Descrição do anúncio:"
                                    required
                                />
                            </div>
                        </div>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    {this.props.PublicarVeiculo.anuncio.idAnuncioBNDV != null
                        && this.props.PublicarVeiculo.anuncio.idAnuncioBNDV != 0
                        ? <BtnCancelar
                            type="button"
                            text=" Remover anúncio"
                            textLoading=" Aguarde..."
                            isLoading={this.props.PublicarVeiculo.isLoading}
                            onClick={() => { this.props.fnRemover(); }}
                        />
                        : null}
                    <BtnSalvar
                        type="submit"
                        text={this.props.PublicarVeiculo.anuncio.idAnuncioBNDV != 0 ? " Alterar Anúncio" : "Publicar Veículo"}
                        textLoading=" Aguarde..."
                        isLoading={this.props.PublicarVeiculo.isLoading}
                    />
                </Modal.Footer>
            </Formsy>
        </Modal>;
    }
}

export default connect(
    state => state.marketing_publicador,
    dispatch => bindActionCreators(actionCreators, dispatch),
    null, {}
)(ModalWebSiteBNDV);